import axios from "../general/HttpClient";

export function SendSMS(to, text) {
    return axios.post("/api/sms/sendSMS", { to, text });
}
